import type { ResultsBundle } from "../cloud/results-contract";
import type { ChartSnapshot } from "../health/chartSeries";

/** Adapt approved metric results to the same chart input used by the local dashboard. */
export function resultsSnapshots(bundle: ResultsBundle): ChartSnapshot[] {
  return bundle.measurement_sets.filter(set => set.kind === "code_scan" && set.visibility === "visible" && set.producer_kind === "github" && set.source_kind === "committed").map(set => {
    const rows=bundle.metric_results.filter(row => row.set_id===set.id && row.set_revision===set.revision);
    const methods=Object.fromEntries(rows.map(row => [row.metric_key,JSON.stringify([
      row.method_id ?? set.id,set.profile,set.source_kind,row.population,row.statistic,row.unit,
      set.context ?? 'local',set.producer_kind ?? 'local',set.environment_digest ?? null,set.baseline_source_id ?? null,
    ])]));
    const states=Object.fromEntries(rows.map(row=>[row.metric_key,row.completeness==='partial'?'partial':row.state==='measured'&&row.completeness!=='complete'?'unavailable':row.state]));
    // Local chart selectors use functionCount as an alias for the stored functions metric.
    if(methods.functions)methods.functionCount=methods.functions;
    if(states.functions)states.functionCount=states.functions;
    return {
      id:`${set.id}:${set.revision}`,collectedAt:set.measured_at,commitTime:set.event_at,
      commitSha:set.commit_sha??null,revisionRef:set.revision_ref,profile:set.profile ?? "unknown",sourceKind:set.source_kind==='working_tree'?'worktree':set.source_kind ?? undefined,
      status:rows.every(row=>row.state==='measured'&&row.completeness==='complete')?'complete':'partial',
      provenance:set.provenance,metricMethods:methods,metricStates:states,
      aggregates:Object.fromEntries(rows.map(row=>[row.metric_key,row.value])),
      sources:rows.map(row=>({adapter:row.metric_key,version:null,status:row.state,warnings:[],methodId:row.method_id??'Unknown'})),
    };
  });
}
